import { AcquisitionRole } from "./aquisition-role.enum";


export const AcquisitionRoleHelperFunc = (assignedRoles: any) => {
  const foundRoles = assignedRoles.filter(item =>
    item?.name?.toLowerCase()?.includes('acquisition') &&
    item?.activities?.match(/\[{\"/g) &&
  (JSON.parse(item?.activities))?.length).map(item => ({
    ...item,
    activities:  JSON.parse(item?.activities)
  }));

  return foundRoles[0]?.['activities']?.map(value => ({
    ...value,
    activityName: value?.activityName ? value?.activityName?.toLowerCase()?.replace(/\s/g, "") : null,
    activitySelectedValue: value?.activitySelectedValue ? value?.activitySelectedValue?.toLowerCase()?.replace(/\s/g, "") : AcquisitionRole.NOACCESS,
  }));
}
